'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { FlexRow } from 'src/components/Atoms/FlexBox';
import { Link } from 'src/components/Atoms/Link';
import { IconButton } from 'src/components/Atoms/IconButton';
import { List } from 'src/components/Molecules/List';
import { ListItem } from 'src/components/Molecules/ListItem';
import Icon from 'src/components/Particles/Icons/Icon';
import Fade from '@mui/material/Fade';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
interface Route {
  name?: string | undefined;
  path?: string;
  icon?: string;
  isActive?: boolean;
  children?: Route[];
}
interface SidebarItemProps {
  route: Route;
  iconOnly?: boolean;
  isActive?: boolean;
  isChild?: boolean;
  expandSidebar?: () => void;
}
const StyledLabelContainer = styled(FlexRow)(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1
}));
const StyledLabel = styled(Typography)(({
  theme
}) => ({
  flex: 1,
  fontSize: theme.fonts.size.sm
}));
const StyledIconButton = styled(IconButton)(() => ({
  padding: '0',
  pointerEvents: 'none',
  width: '20px',
  // TODO: add it from Theme
  height: '20px' // TODO: add it from Theme
}));
const StyledTooltip = styled(({
  className,
  ...props
}: TooltipProps) => <Tooltip {...props} arrow classes={{
  popper: className
}} />)(({
  theme
}) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.surface.brand,
    color: theme.palette.common.white
  }
}));
const SidebarItem: React.FC<SidebarItemProps> = t0 => {
  const $ = _c(61);
  const {
    route: t1,
    iconOnly: t2,
    isActive,
    isChild: t3,
    expandSidebar
  } = t0;
  const {
    name: t4,
    path: t5,
    icon,
    children: t6
  } = t1;
  const name = t4 === undefined ? "" : t4;
  const path = t5 === undefined ? "#" : t5;
  const children = t6 === undefined ? null : t6;
  const iconOnly = t2 === undefined ? false : t2;
  const isChild = t3 === undefined ? false : t3;
  const key = `sidebar-item-${name}-${path}`;
  let t7;
  if ($[0] !== children || $[1] !== isActive) {
    t7 = isActive || children?.some(_temp);
    $[0] = children;
    $[1] = isActive;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const isTreeActive = t7;
  const style = `${isChild ? "child" : ""} ${isTreeActive ? "active" : ""}`;
  let t8;
  if ($[3] !== isTreeActive) {
    t8 = () => isTreeActive ?? false;
    $[3] = isTreeActive;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const [isOpen, setIsOpen] = useState(t8);
  let t10;
  let t9;
  if ($[5] !== isTreeActive) {
    t9 = () => {
      if (isTreeActive) {
        setIsOpen(true);
      }
    };
    t10 = [isTreeActive];
    $[5] = isTreeActive;
    $[6] = t10;
    $[7] = t9;
  } else {
    t10 = $[6];
    t9 = $[7];
  }
  useEffect(t9, t10);
  if (children && children.length > 0) {
    let t11;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = () => {
        setIsOpen(_temp2);
      };
      $[8] = t11;
    } else {
      t11 = $[8];
    }
    const handleToggle = t11;
    const t12 = !iconOnly;
    const t13 = !iconOnly;
    let t14;
    if ($[9] !== expandSidebar) {
      t14 = () => {
        setIsOpen(true);
        expandSidebar?.();
      };
      $[9] = expandSidebar;
      $[10] = t14;
    } else {
      t14 = $[10];
    }
    let t15;
    if ($[11] !== icon) {
      t15 = icon && <Icon icon={icon} size={24} />;
      $[11] = icon;
      $[12] = t15;
    } else {
      t15 = $[12];
    }
    const t16 = !iconOnly;
    let t17;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = {
        minWidth: "150px"
      };
      $[13] = t17;
    } else {
      t17 = $[13];
    }
    let t18;
    if ($[14] !== name) {
      t18 = <StyledLabel sx={t17}>{name}</StyledLabel>;
      $[14] = name;
      $[15] = t18;
    } else {
      t18 = $[15];
    }
    let t19;
    if ($[16] !== isOpen) {
      t19 = <StyledIconButton disableRipple={true}>{isOpen ? <ExpandLess sx={{
          fontSize: 20
        }} /> : <ExpandMore sx={{
          fontSize: 20
        }} />}</StyledIconButton>;
      $[16] = isOpen;
      $[17] = t19;
    } else {
      t19 = $[17];
    }
    let t20;
    if ($[18] !== t18 || $[19] !== t19) {
      t20 = <StyledLabelContainer>{t18}{t19}</StyledLabelContainer>;
      $[18] = t18;
      $[19] = t19;
      $[20] = t20;
    } else {
      t20 = $[20];
    }
    let t21;
    if ($[21] !== t16 || $[22] !== t20) {
      t21 = <Fade in={t16} timeout={400} unmountOnExit={true}>{t20}</Fade>;
      $[21] = t16;
      $[22] = t20;
      $[23] = t21;
    } else {
      t21 = $[23];
    }
    let t22;
    if ($[24] !== style || $[25] !== t13 || $[26] !== t14 || $[27] !== t15 || $[28] !== t21) {
      t22 = <ListItem expandable={t13} handleExpand={handleToggle} className={style} onClick={t14}>{t15}{t21}</ListItem>;
      $[24] = style;
      $[25] = t13;
      $[26] = t14;
      $[27] = t15;
      $[28] = t21;
      $[29] = t22;
    } else {
      t22 = $[29];
    }
    let t23;
    if ($[30] !== name || $[31] !== t12 || $[32] !== t22) {
      t23 = <SmartTooltip isExpanded={t12} title={name}>{t22}</SmartTooltip>;
      $[30] = name;
      $[31] = t12;
      $[32] = t22;
      $[33] = t23;
    } else {
      t23 = $[33];
    }
    let t24;
    if ($[34] !== children || $[35] !== iconOnly || $[36] !== isOpen) {
      t24 = !iconOnly && <List isClosed={!isOpen}>{children.map(_temp3)}</List>;
      $[34] = children;
      $[35] = iconOnly;
      $[36] = isOpen;
      $[37] = t24;
    } else {
      t24 = $[37];
    }
    let t25;
    if ($[38] !== t23 || $[39] !== t24) {
      t25 = <>{t23}{t24}</>;
      $[38] = t23;
      $[39] = t24;
      $[40] = t25;
    } else {
      t25 = $[40];
    }
    return t25;
  }
  const t11 = !iconOnly;
  let t12;
  if ($[41] !== icon) {
    t12 = icon && <Icon icon={icon} size={24} />;
    $[41] = icon;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  const t13 = !iconOnly;
  let t14;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      minWidth: "175px"
    };
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== name) {
    t15 = <StyledLabel sx={t14}>{name}</StyledLabel>;
    $[44] = name;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t13 || $[47] !== t15) {
    t16 = <Fade in={t13} timeout={400} unmountOnExit={true}>{t15}</Fade>;
    $[46] = t13;
    $[47] = t15;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== key || $[50] !== style || $[51] !== t12 || $[52] !== t16) {
    t17 = <ListItem key={key} className={style}>{t12}{t16}</ListItem>;
    $[49] = key;
    $[50] = style;
    $[51] = t12;
    $[52] = t16;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== name || $[55] !== t11 || $[56] !== t17) {
    t18 = <SmartTooltip isExpanded={t11} title={name}>{t17}</SmartTooltip>;
    $[54] = name;
    $[55] = t11;
    $[56] = t17;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] !== path || $[59] !== t18) {
    t19 = <Link href={path} noDecoration={true}>{t18}</Link>;
    $[58] = path;
    $[59] = t18;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  return t19;
};
export default SidebarItem;
export type { SidebarItemProps };
export const dynamic = 'force-dynamic';
type SmartTooltipProps = TooltipProps & {
  isExpanded: boolean;
};
const SmartTooltip = t0 => {
  const $ = _c(9);
  let isExpanded;
  let props;
  if ($[0] !== t0) {
    ({
      isExpanded,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isExpanded;
    $[2] = props;
  } else {
    isExpanded = $[1];
    props = $[2];
  }
  const [open, setOpen] = useState(false);
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(true);
    t2 = () => setOpen(false);
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  const t3 = isExpanded ? false : open;
  let t4;
  if ($[5] !== isExpanded || $[6] !== props || $[7] !== t3) {
    t4 = <StyledTooltip {...props} arrow={true} placement="right" disableInteractive={true} onOpen={t1} onClose={t2} open={t3} disableHoverListener={isExpanded} disableFocusListener={isExpanded} disableTouchListener={isExpanded} />;
    $[5] = isExpanded;
    $[6] = props;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(child) {
  return child?.isActive;
}
function _temp2(prev) {
  return !prev;
}
function _temp3(child_0) {
  return <SidebarItem route={child_0} isChild={true} isActive={child_0.isActive} key={`sub-menu-item-${child_0.path || child_0.name}`} />;
}